import { z } from 'zod';
import { apiKeyInfoSchema, apiKeySchema } from '../api-key.types';
import { workspaceUserSchema } from '../workspace-team.types';

export const apiKeyResponseSchema = z.object({
    uuid: z.string().uuid(),
    user: workspaceUserSchema,
    creationDate: z.string().datetime(),
    expirationDate: z.string().datetime()
});

export const apiKeyListResponse = z.array(apiKeyResponseSchema);

export type ApiKeyListResponse = z.infer<typeof apiKeyListResponse>;

export const apiKeyCreationResponse = z.object({
    uuid: z.string().uuid(),
    apiKey: apiKeySchema
});

export type ApiKeyCreationResponse = z.infer<typeof apiKeyCreationResponse>;
